import { useQuery } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { getApplicationWorkbook } from '../../requests/getApplicationWorkbook';

export const useApplicationWorkbook = (
  uuid: string,
  definitionName: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getApplicationWorkbook>>
  >({
    queryKey: [APPLICATION_BASE_PATH, uuid, 'workbook'],
    queryFn: () => getApplicationWorkbook(constructGet, uuid, definitionName),
    enabled: Boolean(uuid) && (options?.enabled ?? true),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'workbook'),
    ...rest,
  };
};
